import { render, staticRenderFns } from "./AxMonitorContext.vue?vue&type=template&id=543f887e"
import script from "./AxMonitorContext.vue?vue&type=script&lang=ts"
export * from "./AxMonitorContext.vue?vue&type=script&lang=ts"
import style0 from "./AxMonitorContext.vue?vue&type=style&index=0&id=543f887e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports